import { render, staticRenderFns } from "./InventoryPayoffSectionHeader.vue?vue&type=template&id=67eb0227&scoped=true"
import script from "./InventoryPayoffSectionHeader.vue?vue&type=script&lang=js"
export * from "./InventoryPayoffSectionHeader.vue?vue&type=script&lang=js"
import "./InventoryPayoffSectionHeader.vue?vue&type=style&index=0&id=67eb0227&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67eb0227",
  null
  
)

export default component.exports